<template>
<div class="TableBox">
    <search-template page_name="线下补款表" :timeMonth='timeMonth' source="offline" @search_event='search_event'></search-template>
    <div class="operationUploadBox clear" style="margin-top:5px">
        <div class="operationUpload">
            <div class="batchDelete" style="background:#d51414;border-color:#d51414" @click="batchDelete">批量删除</div>
            <div class="batchDelete" style="background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
            <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E7%BA%BF%E4%B8%8B%E8%A1%A5%E6%AC%BE%E6%A8%A1%E6%9D%BF.xlsx'>线下补款导入模板</a>
            <el-upload
                style="display: inline-block;float: left;"
                ref="upload"
                :action="URL.BASEURL + URL.orderImportCost"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-progress='uploadProgress'
                :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                    type: 3
                }"
                :show-file-list='false'
                :auto-upload="true"
                accept=".xlsx,.csv"
                >
                <div class="batchDelete">线下补款批量导入</div>
            </el-upload>
        </div>
        <div class="refreshIcon batchDelete" @click="init({page:1})">
            刷新
            <i class="el-icon-refresh"></i>
        </div>
        <div class="batchDelete" @click="init({page:1,exportFlag:true})">导出</div>
    </div>
     <ux-grid
        class="uxGridBox"
        ref="plxTable"
        :height="height"
        :checkboxConfig="{checkMethod: selectable, highlight: true}"
        @selection-change="selectionChange"
        @table-body-scroll="scroll"
        show-footer-overflow="tooltip"
        show-overflow="tooltip"
        keep-source
        :edit-config="{trigger: 'manual', mode: 'row'}"
        size="mini">
         <ux-table-column type="checkbox" align="center" fixed="left" width="40"/>
         <ux-table-column
                 v-for="item in columns"
                 :key="item.id"
                 :resizable="item.resizable"
                 :field="item.prop"
                 :title="item.label"
                 :width="item.width"
                 show-header-overflow='tooltip'
                 :fixed="item.fixed"
                 :edit-render="item.editRender?true:false"
                 align="center"/>
        <ux-table-column title="状态" align="center" minWidth="60" fixed="right" field="describe">
            <template v-slot="{ row }">
                <span v-if="row.status<3">未锁单</span>
                <div v-else>
                    <span v-if="row.status == 3 && (row.cost_verify_status == 0||!row.cost_verify_status)">媒介锁单</span>
                    <span v-if="row.status == 4 && (row.cost_verify_status == 0||!row.cost_verify_status)">财务锁单</span>
                    <span v-if="row.cost_verify_status == 1">待媒介审核</span>
                    <span v-if="row.cost_verify_status == 2">媒介通过</span>
                    <span v-if="row.cost_verify_status == 3">媒介驳回</span>
                    <span v-if="row.cost_verify_status == 4">财务通过</span>
                    <span v-if="row.cost_verify_status == 5">财务驳回</span>
                </div>
            </template>
        </ux-table-column>
        <ux-table-column title="操作" align="center" minWidth="80" fixed="right" field="describe">
            <template v-slot="{ row }">
                <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;" v-if="row.status>=3&&(row.cost_verify_status==1||row.cost_verify_status==2)" @click="delVerifyOrder(row)">撤销</span>
                <span v-else>
                    <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="editRowEvent(row)">编辑</span>
                </span>
                <span style="color:#5B7BFE;cursor: pointer;" @click="order_id=row.order_id;record_id=row.id;journalFlag=true;">记录</span>
            </template>
        </ux-table-column>
     </ux-grid>
     <div ref="pagination" class="paginationBox footer-wrap" style="height: 30px;">
        <el-pagination
            small
            background
            :current-page="page"
            :page-size="page_size"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="total" />
      <button class="batchDelete btn" @click="init({});moreTotalDataFlag = true">数据合计</button>
    </div>
     <el-dialog title="编辑" :visible.sync="editFlag" width="70%" top="10vh" :close-on-click-modal='false'>
        <offline-edit v-if="editFlag" :editDataTotal='editData' @cancelToast='cancelToast' @emit_refresh="emit_refresh" />
    </el-dialog>
    <!-- 查看日志 -->
    <el-dialog title="订单记录" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
        <journal v-if="journalFlag" @cancelToast='cancelToast' :order_id='order_id' :record_id='record_id' />
    </el-dialog>

    <!-- 底部总数--查看更对数据 -->
    <el-dialog title="数据合计" :visible.sync="moreTotalDataFlag" width="600">
      <div class="totalData">
        <div style="width:50%">
          <p>线下补款金额：{{ $formatNum(orderTotal.offline_subsidy_amount) }}</p>
        </div>
        <div style="width:50%">
          <p>补款总额：{{ $formatNum(orderTotal.rebate) }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moreTotalDataFlag = false" size="mini">确 定</el-button>
      </span>
    </el-dialog>
</div>
</template>
<script>
import journal from '../orderJournal'
import columnsJson from '../json/offline.js'
import searchTemplate from '../searchTemplate.vue'
    import offlineEdit from './offlineEdit'
    export default {
        components:{
            offlineEdit,
            journal,
            searchTemplate
        },
      data() {
        return {
          height: 0,
          columns: [],//表头
          scrollTop: 0,
          loading:false,
          timeMonth:'',
          editData:{},
          editFlag:false,
          multipleSelection:[],
          multipleSelection1:{},
          order_id:'',
          record_id:'',
          journalFlag:false,
          search_data:[],
          page:1,
          page_size:100,
          total:0,
          selectionList:[],
          flag:false,
          moreTotalDataFlag: false,
          orderTotal: {},
        }
      },
      created(){
        var date = new Date();
        if (date.getMonth() === 0) { // 默认值为上个月份；月份为 0 时处理跨年问题
          this.timeMonth = (date.getFullYear() - 1) + '-' + '12'
        } else {
          this.timeMonth = date.getFullYear() + '-' + ((date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth()));
        }
        this.columns = columnsJson
      },
      mounted () {
        this.$nextTick(() => {
          this.computeGridHeight()
          window.addEventListener('resize', this.computeGridHeight, { passive: true })
        })
        this.init({page:1})
      },
      beforeDestroy () {
        try {
          window.removeEventListener('resize', this.computeGridHeight)
        } catch (e) {}
      },
      methods: {
          computeGridHeight () {
            this.$nextTick(() => {
              try {
                const viewportH = window.innerHeight || document.documentElement.clientHeight
                const gridEl = this.$refs.plxTable && this.$refs.plxTable.$el
                const pagEl = this.$refs.pagination
                if (!gridEl) return
                const gridTop = gridEl.getBoundingClientRect().top
                const pagH = pagEl ? pagEl.offsetHeight : 56
                const gap = 16
                const footer = 29
                let h = Math.floor(viewportH - gridTop - pagH - gap - footer)
                if (h < 300) h = 300
                this.height = h
              } catch (e) {
                const h = document.documentElement.clientHeight - 320
                this.height = h > 400 ? h : 400
              }
            })
          },
          search_event(data){
              this.search_data = data;
                this.init({page:1})
          },
          batchDelete(){//批量删除
            if(!this.multipleSelection || this.multipleSelection.length == 0){
                this.$message({
                    message: '未选择要删除的订单',
                    type: 'warning'
                })
                return
            }
            this.$confirm('确定要删除所选中订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    var arr = [];
                    this.multipleSelection.forEach((item)=>{
                        arr.push(item.id)
                    })
                    this.$loading(this.$loadingConfig)
                    this.$axios.post(this.URL.BASEURL + this.URL.offlineDel,{
                        ids: arr
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.$message({
                                message: '删除成功！',
                                type: 'success'
                            })
                            this.init({page:1})
                        }else {
                            this.$loading(this.$loadingConfig).close()
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                        this.$loading(this.$loadingConfig).close()
                    })
                }).catch(() => {
            });
          },
          emit_refresh(){//编辑成功
            this.editFlag = false;
            this.init({page:this.page})
          },
          cancelToast(){
            this.editFlag = false;
            this.journalFlag = false;
            },
          editRowEvent(row){//编辑
            this.editFlag = true;
            this.editData = row;
          },
          uploadSuccess(res, file, fileList){
            this.$loading(this.$loadingConfig).close()
            if(res.errno == 0){
                this.$alert('导入成功！', '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                        this.init({page:1})
                    }
                });
            }else {
                var errHint = ''
                if(Array.isArray(res.rst.error)){
                    errHint = '<p>有误字段：</p><ul>'
                    res.rst.error.forEach((item)=>{
                        errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
                    })
                    errHint += '</ul>'
                }else{
                    errHint = res.rst.error
                }
                this.$alert(errHint, res.err, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
            }
        },
        uploadError(err, file, fileList){
            this.$loading(this.$loadingConfig).close()
            this.$alert('上传失败', '服务器错误', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                }
            });
        },
        uploadProgress(){//上传中
            this.$loading(this.$loadingConfig);
        },
        clearSelection(){//清空选中
            this.$refs.plxTable.clearSelection();
            this.multipleSelection1 = {};
            this.multipleSelection = [];
            this.selectionList = []
        },
        toggleSelection(rows) {
            if (rows) {
            rows.forEach((row,index) => {
                this.$refs.plxTable.toggleRowSelection([
                    {
                        row: row,
                        selected: true
                    }
                ])
                if(index == rows.length-1){
                    this.flag = true
                }
            });
          }
        },
        handleCurrentChange(val){
            this.init({page:val,selection:'clear'})
        },
        init({page,exportFlag,selection}){
            if(!selection || selection != 'clear'){
                this.clearSelection()
            }
            var params = {
                page:page,
                pagesize: this.page_size,
                month:this.timeMonth,
            }
            if(exportFlag){
                params.page = 1;
                params.pagesize = 10000
            }else{
                page = page?page:1;
                params.page = page;
                this.page = page;
            }
            if(this.search_data.length==0){
                params.month = this.timeMonth
            }else{
                this.search_data.forEach((item)=>{
                    if(item.property == 'if_public' || item.property == 'is_refund'){
                        params[item.property] = item.values == '是' ? 1 : null
                    }else{
                        params[item.property] = item.values
                    }
                })
            }
            this.$loading(this.$loadingConfig);
            this.$axios.get(this.URL.BASEURL + this.URL.offlineIndex,{
                params
            }).then((res) => {
                var res=res.data;
                this.$loading(this.$loadingConfig).close()
                if(res&& res.errno == 0){
                    var data = res.rst;
                    if(exportFlag){
                        this.$exportOrder({source:'offline',dataList:data.data,name:'线下补款表'})
                    }else{
                        this.total = data.pageInfo.total;
                        this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
                        this.$refs.plxTable.reloadData(this.datas)
                        this.orderTotal = res.rst.orderTotal;
                        this.$nextTick(()=>{
                            this.computeGridHeight()
                            if(this.multipleSelection1['page_'+this.page] && this.multipleSelection1['page_'+this.page].length != 0){
                                var rows = [],arr = []
                                this.multipleSelection1['page_'+this.page].forEach((item)=>{
                                    arr.push(item.id)
                                })
                                rows = this.datas.filter((v)=>{
                                    return arr.indexOf(v.id) != -1
                                })
                                this.flag =false
                                this.toggleSelection(rows)
                            }else{
                                this.flag = true
                            }
                        })
                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.$loading(this.$loadingConfig).close()
            })
        },
       scroll ({scrollTop, scrollLeft}) {
         this.scrollTop = scrollTop
       },
        selectable ({row}) {//选择表格限制条件
            return row.cost_verify_status != 1 && row.cost_verify_status !=2
        },
        selectionChange (row) {// 选中的行
          this.selectionList = row
          if(this.flag){
            this.multipleSelection1['page_'+this.page] = this.selectionList;
            this.multipleSelection = [];
            for(var i in this.multipleSelection1){
                this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
            }
          }
        },
        delVerifyOrder(data){
            this.$confirm('确定要撤销此订单的修改?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$loading(this.$loadingConfig);
                this.$axios.post(this.URL.BASEURL + this.URL.delVerifyOrder,{
                    order_id: data.order_id,
                    type:2
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.init({page:1})
                    }else {
                        this.$loading(this.$loadingConfig).close();
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                    this.$loading(this.$loadingConfig).close();
                })
            }).catch(()=>{
            })
        },
      },
    }
  </script>
  <style lang="scss" scoped>
  @import '@/assets/css/tableStyle.scss';
  .topOperation{
      display: flex;
      align-items: top;
      .screenBox{
          flex: 1;
      }
  }
  .TableBox{
      padding:15px;
      background: #fff;
      margin-top: 15px;
  }
  .operationUpload,.operationUploadBox{
      display: flex;
      align-items: center;
  }
  .operationUpload{
      flex: 1;
  }
  .fileTemplate{
    font-size: 12px;
    margin-right: 10px;
    text-decoration: underline;
    margin: 8px 10px 0 0;
    color:#5B7BFE;
    display: block;
}
.batchDelete{
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #5B7BFE;
    background: #5B7BFE;
    color: #fff;
    margin-right: 16px;
    cursor: pointer;
    padding: 0 4px;
}
.uxGridBox{
    margin-top: 15px;
}
.refreshIcon{
    margin-right: 10px;
    background: #67c23a;
    border-color:#67c23a ;
  }
  .footer-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
        margin-left: 50px;
    }
  }
  .totalData {
    color: #202652;
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    display: flex;
    &:first-of-type {
      margin-top: -20px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/Order/medium/offlineList.vue